/*
 * 机器生成，不要手改。改动请编辑 scripts/gen_mock_from_real_run.py 后重跑：
 *   python3.11 scripts/gen_mock_from_real_run.py
 *
 * 来源：Asterove_yeoui 仓库的真实管线运行
 *   resources/illustrations/visual-canon/_process/ripple_revision_20260905/pipeline_runs/run_e20_K_gen4_regen_20260907
 *   源图 SHA-256 4d77c2694864b526…
 *
 * 这一次运行走了最长的路径（诊断 → 参考级净化 → 重新生成 → 复诊 → 格子切除 → 验收），
 * 所以能覆盖前端最多的状态。数值全部为管线实测，未经修饰。
 */
import type { Diagnosis, RunRecord } from '../types'

/** 输入图的诊断：叠瓦结构化 23.2%，需要走重新生成路径 */
export const MOCK_DIAGNOSIS: Diagnosis = {
  "pixels": [
    1672,
    941
  ],
  "lattice": {
    "detected": true,
    "components_above_tau": 1164,
    "isolated_components_kept": 1164,
    "rejected_large_components": 0,
    "notched_bins": 1262,
    "notched_bins_pct": 0.0656,
    "max_peak_excess": 4.348,
    "peaks_top": [
      {
        "excess": 4.348,
        "support": 4,
        "period_px": 2.03,
        "angle_deg": -90.0
      },
      {
        "excess": 4.348,
        "support": 4,
        "period_px": 2.03,
        "angle_deg": 90.0
      },
      {
        "excess": 4.129,
        "support": 17,
        "period_px": 2.01,
        "angle_deg": 180.0
      },
      {
        "excess": 4.063,
        "support": 16,
        "period_px": 2.01,
        "angle_deg": 0.0
      },
      {
        "excess": 3.612,
        "support": 12,
        "period_px": 1.43,
        "angle_deg": 135.3
      },
      {
        "excess": 3.489,
        "support": 10,
        "period_px": 1.43,
        "angle_deg": -44.7
      },
      {
        "excess": 3.489,
        "support": 9,
        "period_px": 1.43,
        "angle_deg": -135.3
      },
      {
        "excess": 3.489,
        "support": 8,
        "period_px": 1.43,
        "angle_deg": 44.7
      },
      {
        "excess": 2.094,
        "support": 1,
        "period_px": 2.71,
        "angle_deg": -90.0
      },
      {
        "excess": 2.094,
        "support": 1,
        "period_px": 2.71,
        "angle_deg": 90.0
      },
      {
        "excess": 1.696,
        "support": 2,
        "period_px": 2.85,
        "angle_deg": -44.8
      },
      {
        "excess": 1.696,
        "support": 2,
        "period_px": 2.85,
        "angle_deg": 135.2
      }
    ]
  },
  "granule": {
    "level": "suspected",
    "flagged_windows": 1,
    "flat_windows": [
      {
        "box": [
          598,
          617,
          694,
          713
        ],
        "band_std": 1.2916,
        "kurtosis": 0.19,
        "anisotropy": 0.117,
        "mid_blob_cov_pct": 23.35,
        "mid_blob_median_area": 20.0,
        "flagged": true
      }
    ],
    "oriented_windows": [
      {
        "box": [
          450,
          375,
          546,
          471
        ],
        "band_std": 0.8496,
        "kurtosis": 1.48,
        "anisotropy": 0.729,
        "mid_blob_cov_pct": 19.68,
        "mid_blob_median_area": 31.0
      },
      {
        "box": [
          415,
          9,
          511,
          105
        ],
        "band_std": 3.2625,
        "kurtosis": 0.38,
        "anisotropy": 0.832,
        "mid_blob_cov_pct": 28.06,
        "mid_blob_median_area": 40.0
      },
      {
        "box": [
          912,
          119,
          1008,
          215
        ],
        "band_std": 2.2143,
        "kurtosis": 0.64,
        "anisotropy": 0.758,
        "mid_blob_cov_pct": 24.87,
        "mid_blob_median_area": 34.0
      }
    ]
  },
  "scale_index": {
    "scale_tile_pct": 23.2,
    "level": "structured",
    "tiles": 190,
    "flagged_tiles": 44,
    "median_cov_pct": 22.9,
    "median_area_cv": 0.833,
    "tile": 128,
    "stride": 64,
    "thresholds": {
      "min_cov_pct": 19.0,
      "max_area_cv": 0.65,
      "min_circ": 0.55,
      "max_aniso": 0.35,
      "min_band_std": 0.3,
      "blob_area_min": 12,
      "blob_area_max": 300,
      "suspected_min_pct": 2.0,
      "structured_min_pct": 6.0
    },
    "flagged_tile_boxes": [
      [
        640,
        320,
        768,
        448
      ],
      [
        64,
        384,
        192,
        512
      ],
      [
        128,
        384,
        256,
        512
      ],
      [
        192,
        384,
        320,
        512
      ],
      [
        512,
        384,
        640,
        512
      ],
      [
        640,
        384,
        768,
        512
      ],
      [
        64,
        448,
        192,
        576
      ],
      [
        128,
        448,
        256,
        576
      ],
      [
        192,
        448,
        320,
        576
      ],
      [
        256,
        448,
        384,
        576
      ],
      [
        320,
        448,
        448,
        576
      ],
      [
        512,
        448,
        640,
        576
      ],
      [
        576,
        448,
        704,
        576
      ],
      [
        640,
        448,
        768,
        576
      ],
      [
        704,
        448,
        832,
        576
      ],
      [
        0,
        512,
        128,
        640
      ],
      [
        64,
        512,
        192,
        640
      ],
      [
        128,
        512,
        256,
        640
      ],
      [
        192,
        512,
        320,
        640
      ],
      [
        256,
        512,
        384,
        640
      ],
      [
        320,
        512,
        448,
        640
      ],
      [
        384,
        512,
        512,
        640
      ],
      [
        448,
        512,
        576,
        640
      ],
      [
        512,
        512,
        640,
        640
      ],
      [
        576,
        512,
        704,
        640
      ],
      [
        640,
        512,
        768,
        640
      ],
      [
        704,
        512,
        832,
        640
      ],
      [
        1024,
        512,
        1152,
        640
      ],
      [
        0,
        576,
        128,
        704
      ],
      [
        128,
        576,
        256,
        704
      ],
      [
        192,
        576,
        320,
        704
      ],
      [
        256,
        576,
        384,
        704
      ],
      [
        320,
        576,
        448,
        704
      ],
      [
        384,
        576,
        512,
        704
      ],
      [
        448,
        576,
        576,
        704
      ],
      [
        512,
        576,
        640,
        704
      ],
      [
        576,
        576,
        704,
        704
      ],
      [
        640,
        576,
        768,
        704
      ],
      [
        704,
        576,
        832,
        704
      ],
      [
        768,
        576,
        896,
        704
      ],
      [
        960,
        576,
        1088,
        704
      ],
      [
        1024,
        576,
        1152,
        704
      ],
      [
        1088,
        576,
        1216,
        704
      ],
      [
        1152,
        576,
        1280,
        704
      ]
    ],
    "measured_on": "1280x720",
    "canvas_normalized_for_grading": true,
    "canon_long_edge": 1280,
    "heatmap": "resources/illustrations/visual-canon/_process/ripple_revision_20260905/pipeline_runs/run_e20_K_gen4_regen_20260907/alice_chainK_moments_repeat_gen4_v1_miyang_input_scaleheat.png"
  },
  "flags": {
    "lattice": true,
    "granule_flat": false,
    "granule_pervasive": false,
    "granule_suspected": true,
    "scale_structured": true,
    "scale_suspected": false
  }
}

/**
 * 成品自己的诊断（restored.png，即对比板右侧那张）。
 * 叠瓦从 23.2% 降到 0.5%、鳞片从 suspected 降到 none。
 * 注意 lattice 仍为 true：
 * 格子切除把最强尖峰从 4.348 削到 2.996、保留分量从 1164 降到 578，
 * 但 2 像素量级的周期峰仍在阈值之上，检出标志不会归零。结果页文案必须按
 * 「已削弱」而不是「已清除」来写。
 */
export const MOCK_DIAGNOSIS_AFTER: Diagnosis = {
  "pixels": [
    1665,
    937
  ],
  "lattice": {
    "detected": true,
    "components_above_tau": 578,
    "isolated_components_kept": 578,
    "rejected_large_components": 0,
    "notched_bins": 710,
    "notched_bins_pct": 0.0372,
    "max_peak_excess": 2.996,
    "peaks_top": [
      {
        "excess": 2.996,
        "support": 12,
        "period_px": 2.02,
        "angle_deg": -90.0
      },
      {
        "excess": 2.996,
        "support": 12,
        "period_px": 2.02,
        "angle_deg": 90.0
      },
      {
        "excess": 2.812,
        "support": 11,
        "period_px": 2.02,
        "angle_deg": 180.0
      },
      {
        "excess": 2.812,
        "support": 11,
        "period_px": 2.02,
        "angle_deg": 0.0
      },
      {
        "excess": 2.338,
        "support": 5,
        "period_px": 2.85,
        "angle_deg": -45.0
      },
      {
        "excess": 2.338,
        "support": 5,
        "period_px": 2.85,
        "angle_deg": 135.0
      },
      {
        "excess": 1.686,
        "support": 2,
        "period_px": 2.7,
        "angle_deg": -90.0
      },
      {
        "excess": 1.686,
        "support": 2,
        "period_px": 2.7,
        "angle_deg": 90.0
      },
      {
        "excess": 1.475,
        "support": 1,
        "period_px": 5.55,
        "angle_deg": 180.0
      },
      {
        "excess": 1.475,
        "support": 1,
        "period_px": 5.55,
        "angle_deg": 0.0
      },
      {
        "excess": 1.45,
        "support": 1,
        "period_px": 1.91,
        "angle_deg": -45.0
      },
      {
        "excess": 1.45,
        "support": 1,
        "period_px": 1.91,
        "angle_deg": 135.0
      }
    ]
  },
  "granule": {
    "level": "none",
    "flagged_windows": 0,
    "flat_windows": [],
    "oriented_windows": [
      {
        "box": [
          947,
          179,
          1043,
          275
        ],
        "band_std": 1.7656,
        "kurtosis": 0.29,
        "anisotropy": 0.94,
        "mid_blob_cov_pct": 25.33,
        "mid_blob_median_area": 63.0
      },
      {
        "box": [
          1025,
          0,
          1121,
          96
        ],
        "band_std": 1.7068,
        "kurtosis": 2.68,
        "anisotropy": 0.941,
        "mid_blob_cov_pct": 24.84,
        "mid_blob_median_area": 42.5
      },
      {
        "box": [
          916,
          82,
          1012,
          178
        ],
        "band_std": 2.1383,
        "kurtosis": 1.04,
        "anisotropy": 0.943,
        "mid_blob_cov_pct": 26.3,
        "mid_blob_median_area": 53.0
      }
    ]
  },
  "scale_index": {
    "scale_tile_pct": 0.5,
    "level": "none",
    "tiles": 190,
    "flagged_tiles": 1,
    "median_cov_pct": 20.1,
    "median_area_cv": 0.891,
    "tile": 128,
    "stride": 64,
    "thresholds": {
      "min_cov_pct": 19.0,
      "max_area_cv": 0.65,
      "min_circ": 0.55,
      "max_aniso": 0.35,
      "min_band_std": 0.3,
      "blob_area_min": 12,
      "blob_area_max": 300,
      "suspected_min_pct": 2.0,
      "structured_min_pct": 6.0
    },
    "flagged_tile_boxes": [
      [
        128,
        512,
        256,
        640
      ]
    ],
    "measured_on": "1280x720",
    "canvas_normalized_for_grading": true,
    "canon_long_edge": 1280,
    "heatmap": "/Users/easontsui/Documents/GitHub/Asterove_yeoui/resources/illustrations/visual-canon/_process/ripple_revision_20260905/pipeline_runs/run_e20_K_gen4_regen_20260907/alice_chainK_moments_repeat_gen4_v1_miyang_restored_scaleheat.png"
  },
  "flags": {
    "lattice": true,
    "granule_flat": false,
    "granule_pervasive": false,
    "granule_suspected": false,
    "scale_structured": false,
    "scale_suspected": false
  }
}

/*
 * 完整运行记录，7 个步骤。
 *
 * reason 这一栏原本是管线产出的韩语，现已换成服务端实际会发出来的中文
 * （lab_ripple_api 的 core/step_reason.py 按同样的动作序列生成）。录像与真作业
 * 必须长得一样：录像里留韩语的话，演示屏与截图上会出现真实用户永远看不到的东西。
 */
export const MOCK_RUN: RunRecord = {
  "stage": "restore",
  "outcome": "delivered",
  "source": "alice_chainK_moments_repeat_gen4_v1_miyang.png",
  "source_sha256": "4d77c2694864b526dd7390f55d798bf9258f2b86b74d65204b60b21e5463eafd",
  "final": "alice_chainK_moments_repeat_gen4_v1_miyang_restored.png",
  "final_sha256": "d7b8d81a43d4e5d9375ad9112f0e83a5dabdcba9e0e7471d3dfb85634fd92a46",
  "final_is_source_copy": false,
  "regen_rounds": 1,
  "mode": "rules",
  "verify": {
    "passed": true,
    "reasons": []
  },
  "steps": [
    {
      "n": 1,
      "action": "diagnose",
      "by": "rules",
      "reason": "还没看过这张图，先做全幅频域分析与分块统计。这一步不改动图像。",
      "result": {
        "action": "diagnose",
        "lattice": true,
        "granule_level": "suspected",
        "scale_tile_pct": 23.2,
        "scale_level": "structured"
      }
    },
    {
      "n": 2,
      "action": "reference_clean",
      "by": "rules",
      "reason": "全幅叠瓦指数 23.2%，已达结构化。结构化的鳞片已经长进画面结构，滤波器清不掉，只能先净化出一张参考本，再据它重画。",
      "result": {
        "action": "reference_clean",
        "face_detection": "haar_cascade",
        "face_boxes": [
          [
            740,
            473,
            836,
            569
          ],
          [
            1155,
            74,
            1239,
            158
          ],
          [
            1193,
            170,
            1268,
            245
          ],
          [
            1425,
            280,
            1487,
            342
          ]
        ]
      }
    },
    {
      "n": 3,
      "action": "regenerate",
      "by": "rules",
      "reason": "以参考级净化本为唯一依据重画整幅画面。参考本之外不给别的输入，画面才不会跑偏。",
      "result": {
        "action": "regenerate",
        "saved_size": [
          1665,
          937
        ],
        "size_verified": false
      }
    },
    {
      "n": 4,
      "action": "diagnose",
      "by": "rules",
      "reason": "重画之后再诊断一次，看纹理是不是真的降下去了。",
      "result": {
        "action": "diagnose",
        "lattice": true,
        "granule_level": "none",
        "scale_tile_pct": 0.5,
        "scale_level": "none"
      }
    },
    {
      "n": 5,
      "action": "notch",
      "by": "rules",
      "reason": "重画之后仍有孤立的周期尖峰，做一次无损切除收尾。",
      "result": {
        "action": "notch",
        "components_above_tau": 1030,
        "isolated_components_kept": 1030,
        "rejected_large_components": 0,
        "notched_bins": 1320,
        "notched_bins_pct": 0.0691,
        "max_peak_excess": 3.534,
        "energy_removed_pct": 0.03843
      }
    },
    {
      "n": 6,
      "action": "verify",
      "by": "rules",
      "reason": "把处理前后放在一起复诊，确认异常真的降下去了、画面也没有被削平。",
      "result": {
        "action": "verify",
        "passed": true,
        "reasons": []
      }
    },
    {
      "n": 7,
      "action": "finish",
      "by": "rules",
      "reason": "处理完成，产物已就绪。",
      "result": {
        "action": "finish"
      }
    }
  ],
  "time": "2026-09-07T00:58:40+09:00"
}

/**
 * 只有格子纹的真实案例：叠瓦 0.0%、鳞片 none，只需无损切除。
 * 这是生成图能达到的最好状态。现行 schema 的全部运行里 lattice 都为 true，
 * 所以「三项全干净」这一档对 AI 生成图基本不会出现。
 */
export const MOCK_DIAGNOSIS_LATTICE_ONLY: Diagnosis = {
  "pixels": [
    1672,
    941
  ],
  "lattice": {
    "detected": true,
    "components_above_tau": 1346,
    "isolated_components_kept": 1342,
    "rejected_large_components": 4,
    "notched_bins": 2017,
    "notched_bins_pct": 0.1048,
    "max_peak_excess": 3.518,
    "peaks_top": [
      {
        "excess": 3.518,
        "support": 21,
        "period_px": 2.03,
        "angle_deg": -90.0
      },
      {
        "excess": 3.518,
        "support": 21,
        "period_px": 2.03,
        "angle_deg": 90.0
      },
      {
        "excess": 3.011,
        "support": 13,
        "period_px": 1.43,
        "angle_deg": 135.3
      },
      {
        "excess": 2.947,
        "support": 12,
        "period_px": 1.43,
        "angle_deg": -44.7
      },
      {
        "excess": 2.921,
        "support": 11,
        "period_px": 1.43,
        "angle_deg": -135.3
      },
      {
        "excess": 2.827,
        "support": 11,
        "period_px": 1.43,
        "angle_deg": 44.7
      },
      {
        "excess": 2.486,
        "support": 4,
        "period_px": 2.85,
        "angle_deg": -44.8
      },
      {
        "excess": 2.486,
        "support": 4,
        "period_px": 2.85,
        "angle_deg": 135.2
      },
      {
        "excess": 1.725,
        "support": 1,
        "period_px": 2.01,
        "angle_deg": 0.2
      },
      {
        "excess": 1.721,
        "support": 2,
        "period_px": 1.9,
        "angle_deg": -44.7
      },
      {
        "excess": 1.721,
        "support": 2,
        "period_px": 1.9,
        "angle_deg": 135.3
      },
      {
        "excess": 1.699,
        "support": 26,
        "period_px": 2.55,
        "angle_deg": 180.0
      }
    ]
  },
  "granule": {
    "level": "none",
    "flagged_windows": 0,
    "flat_windows": [
      {
        "box": [
          865,
          432,
          961,
          528
        ],
        "band_std": 0.2207,
        "kurtosis": 1.4,
        "anisotropy": 0.206,
        "mid_blob_cov_pct": 20.8,
        "mid_blob_median_area": 18.0,
        "flagged": false
      },
      {
        "box": [
          953,
          45,
          1049,
          141
        ],
        "band_std": 0.1764,
        "kurtosis": 0.15,
        "anisotropy": 0.088,
        "mid_blob_cov_pct": 22.36,
        "mid_blob_median_area": 20.0,
        "flagged": false
      },
      {
        "box": [
          1531,
          60,
          1627,
          156
        ],
        "band_std": 0.1605,
        "kurtosis": 0.07,
        "anisotropy": 0.072,
        "mid_blob_cov_pct": 24.05,
        "mid_blob_median_area": 23.0,
        "flagged": false
      },
      {
        "box": [
          1565,
          186,
          1661,
          282
        ],
        "band_std": 0.1485,
        "kurtosis": 0.38,
        "anisotropy": 0.035,
        "mid_blob_cov_pct": 23.97,
        "mid_blob_median_area": 18.0,
        "flagged": false
      }
    ],
    "oriented_windows": [
      {
        "box": [
          274,
          132,
          370,
          228
        ],
        "band_std": 1.601,
        "kurtosis": 0.21,
        "anisotropy": 0.855,
        "mid_blob_cov_pct": 27.24,
        "mid_blob_median_area": 28.5
      },
      {
        "box": [
          400,
          72,
          496,
          168
        ],
        "band_std": 1.5395,
        "kurtosis": 28.69,
        "anisotropy": 0.898,
        "mid_blob_cov_pct": 22.02,
        "mid_blob_median_area": 31.0
      },
      {
        "box": [
          425,
          257,
          521,
          353
        ],
        "band_std": 1.772,
        "kurtosis": -0.34,
        "anisotropy": 0.877,
        "mid_blob_cov_pct": 28.48,
        "mid_blob_median_area": 38.5
      }
    ]
  },
  "scale_index": {
    "scale_tile_pct": 0.0,
    "level": "none",
    "tiles": 325,
    "flagged_tiles": 0,
    "median_cov_pct": 17.9,
    "median_area_cv": 0.908,
    "tile": 128,
    "stride": 64,
    "thresholds": {
      "min_cov_pct": 19.0,
      "max_area_cv": 0.65,
      "min_circ": 0.55,
      "max_aniso": 0.35,
      "min_band_std": 0.3,
      "blob_area_min": 12,
      "blob_area_max": 300,
      "suspected_min_pct": 2.0,
      "structured_min_pct": 6.0
    },
    "flagged_tile_boxes": [],
    "heatmap": "resources/illustrations/visual-canon/_process/ripple_revision_20260905/pipeline_runs/run_e13_C_gen4_noregen/alice_chainC_moments_repeat_gen4_v1_miyang_input_scaleheat.png"
  },
  "flags": {
    "lattice": true,
    "granule_flat": false,
    "granule_pervasive": false,
    "granule_suspected": false,
    "scale_structured": false,
    "scale_suspected": false
  }
}

/**
 * 上面那张只做了格子切除之后的成品诊断。
 * 最强尖峰 3.518 → 3.097，保留分量 1342 → 868，
 * 但 detected 仍为 true。
 * 两次真跑（链 K 与链 C）都是这个规律：切除削弱尖峰，不会让检出归零。
 */
export const MOCK_DIAGNOSIS_LATTICE_ONLY_AFTER: Diagnosis = {
  "pixels": [
    1672,
    941
  ],
  "lattice": {
    "detected": true,
    "components_above_tau": 872,
    "isolated_components_kept": 868,
    "rejected_large_components": 4,
    "notched_bins": 1602,
    "notched_bins_pct": 0.0833,
    "max_peak_excess": 3.097,
    "peaks_top": [
      {
        "excess": 3.097,
        "support": 10,
        "period_px": 2.03,
        "angle_deg": -90.0
      },
      {
        "excess": 3.097,
        "support": 10,
        "period_px": 2.03,
        "angle_deg": 90.0
      },
      {
        "excess": 2.297,
        "support": 3,
        "period_px": 2.85,
        "angle_deg": -44.8
      },
      {
        "excess": 2.297,
        "support": 3,
        "period_px": 2.85,
        "angle_deg": 135.2
      },
      {
        "excess": 2.212,
        "support": 6,
        "period_px": 1.43,
        "angle_deg": 135.3
      },
      {
        "excess": 2.051,
        "support": 6,
        "period_px": 1.43,
        "angle_deg": -135.3
      },
      {
        "excess": 1.993,
        "support": 3,
        "period_px": 1.43,
        "angle_deg": -44.7
      },
      {
        "excess": 1.927,
        "support": 5,
        "period_px": 1.43,
        "angle_deg": 44.7
      },
      {
        "excess": 1.71,
        "support": 1,
        "period_px": 1.81,
        "angle_deg": -116.8
      },
      {
        "excess": 1.71,
        "support": 1,
        "period_px": 1.81,
        "angle_deg": 63.2
      },
      {
        "excess": 1.672,
        "support": 60,
        "period_px": 2.46,
        "angle_deg": 180.0
      },
      {
        "excess": 1.672,
        "support": 60,
        "period_px": 2.46,
        "angle_deg": 0.0
      }
    ]
  },
  "granule": {
    "level": "none",
    "flagged_windows": 0,
    "flat_windows": [
      {
        "box": [
          865,
          432,
          961,
          528
        ],
        "band_std": 0.2214,
        "kurtosis": 1.38,
        "anisotropy": 0.203,
        "mid_blob_cov_pct": 20.18,
        "mid_blob_median_area": 17.0,
        "flagged": false
      },
      {
        "box": [
          952,
          45,
          1048,
          141
        ],
        "band_std": 0.176,
        "kurtosis": 0.14,
        "anisotropy": 0.095,
        "mid_blob_cov_pct": 22.42,
        "mid_blob_median_area": 20.5,
        "flagged": false
      },
      {
        "box": [
          1458,
          9,
          1554,
          105
        ],
        "band_std": 0.1637,
        "kurtosis": 0.2,
        "anisotropy": 0.076,
        "mid_blob_cov_pct": 24.06,
        "mid_blob_median_area": 21.0,
        "flagged": false
      },
      {
        "box": [
          1508,
          152,
          1604,
          248
        ],
        "band_std": 0.1604,
        "kurtosis": 0.24,
        "anisotropy": 0.108,
        "mid_blob_cov_pct": 24.35,
        "mid_blob_median_area": 20.0,
        "flagged": false
      },
      {
        "box": [
          1560,
          50,
          1656,
          146
        ],
        "band_std": 0.1546,
        "kurtosis": 0.16,
        "anisotropy": 0.034,
        "mid_blob_cov_pct": 23.57,
        "mid_blob_median_area": 23.0,
        "flagged": false
      }
    ],
    "oriented_windows": [
      {
        "box": [
          274,
          132,
          370,
          228
        ],
        "band_std": 1.5979,
        "kurtosis": 0.2,
        "anisotropy": 0.854,
        "mid_blob_cov_pct": 27.17,
        "mid_blob_median_area": 26.5
      },
      {
        "box": [
          400,
          72,
          496,
          168
        ],
        "band_std": 1.5397,
        "kurtosis": 28.4,
        "anisotropy": 0.898,
        "mid_blob_cov_pct": 21.93,
        "mid_blob_median_area": 33.0
      },
      {
        "box": [
          425,
          257,
          521,
          353
        ],
        "band_std": 1.7709,
        "kurtosis": -0.34,
        "anisotropy": 0.877,
        "mid_blob_cov_pct": 28.58,
        "mid_blob_median_area": 38.5
      }
    ]
  },
  "scale_index": {
    "scale_tile_pct": 0.0,
    "level": "none",
    "tiles": 190,
    "flagged_tiles": 0,
    "median_cov_pct": 14.7,
    "median_area_cv": 0.887,
    "tile": 128,
    "stride": 64,
    "thresholds": {
      "min_cov_pct": 19.0,
      "max_area_cv": 0.65,
      "min_circ": 0.55,
      "max_aniso": 0.35,
      "min_band_std": 0.3,
      "blob_area_min": 12,
      "blob_area_max": 300,
      "suspected_min_pct": 2.0,
      "structured_min_pct": 6.0
    },
    "flagged_tile_boxes": [],
    "measured_on": "1280x720",
    "canvas_normalized_for_grading": true,
    "canon_long_edge": 1280,
    "heatmap": "/Users/easontsui/Documents/GitHub/Asterove_yeoui/resources/illustrations/visual-canon/_process/ripple_revision_20260905/pipeline_runs/run_e13_C_gen4_noregen/alice_chainC_moments_repeat_gen4_v1_miyang_restored_scaleheat.png"
  },
  "flags": {
    "lattice": true,
    "granule_flat": false,
    "granule_pervasive": false,
    "granule_suspected": false,
    "scale_structured": false,
    "scale_suspected": false
  }
}
